import Tabs, { TabItem } from "smart-webcomponents-react/tabs";

import IMemo from "../../../Sections/ElementsSections/Forms/Components/IMemo";
import TicketsClosingDetailPanel from "./TicketsClosingDetailPanel";
import { Feedback } from "./TicketsList";
import React from "react";

interface TicketsListDetailsProps {
  description: string;
  solution: string;
  status: string;
  sendTaskFeedback: (feedback: Feedback) => void;
}

export default function TicketsListDetails({
  description,
  solution,
  status,
  sendTaskFeedback,
}: TicketsListDetailsProps) {
  return (
    <Tabs id="supportRequestForm" style={{ width: "100%", height: "100%" }}>
      <TabItem
        id="Description"
        label="Описание"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <IMemo
          Text={description}
          readOnly={true}
          style={{
            height: "100%",
            width: "100%",
            resize: "none",
            overflow: "auto",
            outline: "none",
          }}
        />
      </TabItem>
      <TabItem
        id="Solution"
        label="Решение"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <IMemo
          Text={solution}
          readOnly={true}
          style={{
            height: "100%",
            width: "100%",
            resize: "none",
            overflow: "auto",
            outline: "none",
          }}
        />
      </TabItem>
      <TabItem
        id="Closing"
        label="Закрытие"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          display: "inline-block",
        }}
      >
        <TicketsClosingDetailPanel status={status} sendTaskFeedback={sendTaskFeedback} />
      </TabItem>
    </Tabs>
  );
}
